import { render, staticRenderFns } from "./DepartamentoResponsavelModal.vue?vue&type=template&id=3a0c27d9&scoped=true"
import script from "./DepartamentoResponsavelModal.vue?vue&type=script&lang=js"
export * from "./DepartamentoResponsavelModal.vue?vue&type=script&lang=js"
import style0 from "./DepartamentoResponsavelModal.vue?vue&type=style&index=0&id=3a0c27d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0c27d9",
  null
  
)

export default component.exports